import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Svg from "../Svg";
import { SvgProps } from "../types";
import dummy from "../../../../assets/images/wavy-bg.svg";

const Icon: React.FC<SvgProps> = (props) => {
  let navigate = useNavigate();
  const [showSvg, setShowSvg] = useState(false);

  // const { setMainParams} = useContext(APIContext)
  // const [data, setData] = useState([])
  // const resp = useGetTeamDetails();

  useEffect(() => {
    if (localStorage.getItem("label") === "meta-narrative") {
      if (props.data.length < 1) {
        setShowSvg(false);
      } else if (props.data.length > 0) {
        setShowSvg(true);
      }
    }
  }, [props.data]);

  // useEffect(()=>{

  // },[data])

  return (
    <>
      {showSvg && (
        <Svg viewBox="0 0 1714.5 605.043">
          <defs>
            <filter
              id="Path_337"
              x="82.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2"
              x="87.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-2" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-2" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-2"
              x="353.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-3" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-3" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-2"
              x="358.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-4" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-4" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-3"
              x="625.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-5" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-5" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-3"
              x="630.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-6" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-6" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-4"
              x="896.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-7" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-7" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-4"
              x="901.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-8" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-8" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-5"
              x="1438.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-9" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-9" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-5"
              x="1443.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-10" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-10" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-6"
              x="1167.477"
              y="259.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-11" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-11" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-6"
              x="1172.664"
              y="281.135"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-12" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-12" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-7"
              x="218.479"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-13" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-13" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-7"
              x="223.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-14" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-14" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-8"
              x="489.479"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-15" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-15" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-8"
              x="494.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-16" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-16" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-9"
              x="760.504"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-17" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-17" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-9"
              x="765.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-18" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-18" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-10"
              x="1031.479"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-19" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-19" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-10"
              x="1036.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-20" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-20" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-11"
              x="1574.479"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-21" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-21" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-11"
              x="1579.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-22" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-22" />
              <feComposite in="SourceGraphic" />
            </filter>
            an issu
            <filter
              id="Path_337-12"
              x="1303.479"
              y="278.746"
              width="57.025"
              height="73.285"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-23" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-23" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-12"
              x="1308.666"
              y="284.191"
              width="46.453"
              height="46.453"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-24" />
              <feFlood floodOpacity="0.161" />
              <feComposite operator="in" in2="blur-24" />
              <feComposite in="SourceGraphic" />
            </filter>
            <pattern
              id="pattern"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[0].url
                  }
                  style={{
                    opacity:
                      props.data[0]?.characters.length > 0
                        ? "1"
                        : props.data[0]?.story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.data[0].characters.length > 0
                      ? navigate(`/stories/${props.data[0].id}`)
                      : props.data[0].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[0].id}`)
                  }
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern2"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[1].url
                  }
                  style={{
                    opacity:
                      props.data[1].characters.length > 0
                        ? "1"
                        : props.data[1].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern3"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[2].url
                  }
                  style={{
                    opacity:
                      props.data[2].characters.length > 0
                        ? "1"
                        : props.data[2].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern4"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[3].url
                  }
                  style={{
                    opacity:
                      props.data[3].characters.length > 0
                        ? "1"
                        : props.data[3].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern5"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[4].url
                  }
                  style={{
                    opacity:
                      props.data[4].characters.length > 0
                        ? "1"
                        : props.data[4].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern6"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[5].url
                  }
                  style={{
                    opacity:
                      props.data[5].characters.length > 0
                        ? "1"
                        : props.data[5].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern7"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[6].url
                  }
                  style={{
                    opacity:
                      props.data[6].characters.length > 0
                        ? "1"
                        : props.data[6].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern8"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[7].url
                  }
                  style={{
                    opacity:
                      props.data[7].characters.length > 0
                        ? "1"
                        : props.data[7].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern9"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[8].url
                  }
                  href={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[8].url
                  }
                  style={{
                    opacity:
                      props.data[8].characters.length > 0
                        ? "1"
                        : props.data[8].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern10"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[9].url
                  }
                  style={{
                    opacity:
                      props.data[9].characters.length > 0
                        ? "1"
                        : props.data[9].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern11"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[10].url
                  }
                  style={{
                    opacity:
                      props.data[10].characters.length > 0
                        ? "1"
                        : props.data[10].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern12"
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 200 183"
            >
              {props.data.length > 1 ? (
                <image
                  width="215"
                  height="183"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[11].url
                  }
                  style={{
                    opacity:
                      props.data[11].characters.length > 0
                        ? "1"
                        : props.data[11].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern-7"
              width="1"
              height="1"
              patternTransform="matrix(1, 0, 0, -1, 0, 498.085)"
              viewBox="0 0 225 249.043"
            >
              {/* <use preserveAspectRatio="none" xlinkHref="#image" /> */}
            </pattern>
            <image
              id="image"
              preserveAspectRatio="none"
              width="225"
              height="249.043"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
          <g
            id="Group_276"
            data-name="Group 276"
            transform="translate(24230.504 24376)"
          >
            <line
              id="Line_3"
              data-name="Line 3"
              x2="1502.771"
              transform="translate(-24119.195 -24072.322)"
              fill="none"
              stroke="#67bb4f"
              strokeWidth="6"
            />
            <g
              id="Point_Up"
              data-name="Point Up"
              transform="translate(-24139.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -91.48, -265.75)"
                filter="url(#Path_337)"
              >
                <g
                  id="Path_337-13"
                  data-name="Path 337"
                  transform="translate(91.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -91.48, -265.75)"
                filter="url(#Ellipse_2)"
              >
                <g
                  id="Ellipse_2-13"
                  data-name="Ellipse 2"
                  transform="translate(96.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-2"
              data-name="Point Up"
              transform="translate(-23868.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -362.48, -265.75)"
                filter="url(#Path_337-2)"
              >
                <g
                  id="Path_337-14"
                  data-name="Path 337"
                  transform="translate(362.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -362.48, -265.75)"
                filter="url(#Ellipse_2-2)"
              >
                <g
                  id="Ellipse_2-14"
                  data-name="Ellipse 2"
                  transform="translate(367.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-3"
              data-name="Point Up"
              transform="translate(-23596.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -634.48, -265.75)"
                filter="url(#Path_337-3)"
              >
                <g
                  id="Path_337-15"
                  data-name="Path 337"
                  transform="translate(634.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -634.48, -265.75)"
                filter="url(#Ellipse_2-3)"
              >
                <g
                  id="Ellipse_2-15"
                  data-name="Ellipse 2"
                  transform="translate(639.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-4"
              data-name="Point Up"
              transform="translate(-23325.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -905.48, -265.75)"
                filter="url(#Path_337-4)"
              >
                <g
                  id="Path_337-16"
                  data-name="Path 337"
                  transform="translate(905.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -905.48, -265.75)"
                filter="url(#Ellipse_2-4)"
              >
                <g
                  id="Ellipse_2-16"
                  data-name="Ellipse 2"
                  transform="translate(910.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-5"
              data-name="Point Up"
              transform="translate(-22783.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -1447.48, -265.75)"
                filter="url(#Path_337-5)"
              >
                <g
                  id="Path_337-17"
                  data-name="Path 337"
                  transform="translate(1447.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -1447.48, -265.75)"
                filter="url(#Ellipse_2-5)"
              >
                <g
                  id="Ellipse_2-17"
                  data-name="Ellipse 2"
                  transform="translate(1452.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-6"
              data-name="Point Up"
              transform="translate(-23054.027 -24110.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -1176.48, -265.75)"
                filter="url(#Path_337-6)"
              >
                <g
                  id="Path_337-18"
                  data-name="Path 337"
                  transform="translate(1176.48 283.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.51291465759277 36.8699836730957 C 16.94596481323242 36.8699836730957 14.45607471466064 36.36735534667969 12.11238479614258 35.37606430053711 C 9.848404884338379 34.41847229003906 7.815034866333008 33.04750442504883 6.06875467300415 31.30123329162598 C 4.322484493255615 29.55495452880859 2.951514720916748 27.52158355712891 1.993924617767334 25.25760459899902 C 1.002634644508362 22.91391372680664 0.5000046491622925 20.42402458190918 0.5000046491622925 17.85707473754883 C 0.5000046491622925 12.43379402160645 5.519394874572754 3.332024097442627 9.730144500732422 -3.34842586517334 C 14.01375675201416 -10.14447402954102 18.32589530944824 -15.82877922058105 19.51291465759277 -17.20881462097168 C 20.69993591308594 -15.82877922058105 25.01208305358887 -10.14447402954102 29.29569435119629 -3.34842586517334 C 33.50644302368164 3.332024097442627 38.52583312988281 12.43379402160645 38.52583312988281 17.85707473754883 C 38.52583312988281 20.42402458190918 38.0232048034668 22.91391372680664 37.03190612792969 25.25760459899902 C 36.07432556152344 27.52158355712891 34.70335388183594 29.55495452880859 32.95707321166992 31.30123329162598 C 31.2108039855957 33.04750442504883 29.17742538452148 34.41847229003906 26.91344451904297 35.37606430053711 C 24.56975555419922 36.36735534667969 22.07986450195312 36.8699836730957 19.51291465759277 36.8699836730957 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51291465759277 -16.42551422119141 C 17.96053314208984 -14.50749588012695 13.94887351989746 -9.119771957397461 10.0571346282959 -2.929325103759766 C 7.396903991699219 1.302204132080078 5.276683807373047 5.129254341125488 3.755386352539062 8.445524215698242 C 1.927043914794922 12.4310941696167 0.9999961853027344 15.59759426116943 0.9999961853027344 17.85706329345703 C 0.9999961853027344 20.35673332214355 1.489334106445312 22.78110504150391 2.454425811767578 25.06282424926758 C 3.386795043945312 27.26720428466797 4.721786499023438 29.24715423583984 6.422306060791016 30.94767379760742 C 8.122823715209961 32.648193359375 10.10277557373047 33.98318481445312 12.30715560913086 34.91555404663086 C 14.58887481689453 35.88064575195312 17.01324462890625 36.3699836730957 19.51291465759277 36.3699836730957 C 22.0125846862793 36.3699836730957 24.43694496154785 35.88064575195312 26.71866607666016 34.91555404663086 C 28.92305374145508 33.98318481445312 30.90300369262695 32.648193359375 32.603515625 30.94767379760742 C 34.30403518676758 29.24715423583984 35.63902282714844 27.26720428466797 36.57139587402344 25.06282424926758 C 37.53648376464844 22.78110504150391 38.02582550048828 20.35673332214355 38.02582550048828 17.85706329345703 C 38.02582550048828 15.59759426116943 37.09877395629883 12.4310941696167 35.27043533325195 8.445524215698242 C 33.7491340637207 5.129254341125488 31.62892532348633 1.302204132080078 28.96868515014648 -2.929325103759766 C 25.07694625854492 -9.119771957397461 21.06529235839844 -14.50749588012695 19.51291465759277 -16.42551422119141 M 19.51291465759277 -17.916015625 C 19.94218444824219 -17.916015625 39.02582550048828 7.080384254455566 39.02582550048828 17.85706329345703 C 39.02582550048828 28.63375473022461 30.28959465026855 37.3699836730957 19.51291465759277 37.3699836730957 C 8.736225128173828 37.3699836730957 -3.814697265625e-06 28.63375473022461 -3.814697265625e-06 17.85706329345703 C -3.814697265625e-06 7.080384254455566 19.08364486694336 -17.916015625 19.51291465759277 -17.916015625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -1176.48, -265.75)"
                filter="url(#Ellipse_2-6)"
              >
                <g
                  id="Ellipse_2-18"
                  data-name="Ellipse 2"
                  transform="translate(1181.66 287.13)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <circle cx="14.226" cy="14.226" r="14.226" stroke="none" />
                  <circle cx="14.226" cy="14.226" r="13.726" fill="none" />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-7"
              data-name="Point Up"
              transform="translate(-24003.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -227.48, -284.75)"
                filter="url(#Path_337-7)"
              >
                <g
                  id="Path_337-19"
                  data-name="Path 337"
                  transform="translate(227.48 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -227.48, -284.75)"
                filter="url(#Ellipse_2-7)"
              >
                <g
                  id="Ellipse_2-19"
                  data-name="Ellipse 2"
                  transform="translate(232.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-8"
              data-name="Point Up"
              transform="translate(-23732.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -498.48, -284.75)"
                filter="url(#Path_337-8)"
              >
                <g
                  id="Path_337-20"
                  data-name="Path 337"
                  transform="translate(498.48 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -498.48, -284.75)"
                filter="url(#Ellipse_2-8)"
              >
                <g
                  id="Ellipse_2-20"
                  data-name="Ellipse 2"
                  transform="translate(503.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-9"
              data-name="Point Up"
              transform="translate(-23461.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -769.48, -284.75)"
                filter="url(#Path_337-9)"
              >
                <g
                  id="Path_337-21"
                  data-name="Path 337"
                  transform="translate(769.5 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -769.48, -284.75)"
                filter="url(#Ellipse_2-9)"
              >
                <g
                  id="Ellipse_2-21"
                  data-name="Ellipse 2"
                  transform="translate(774.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-10"
              data-name="Point Up"
              transform="translate(-23190.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -1040.48, -284.75)"
                filter="url(#Path_337-10)"
              >
                <g
                  id="Path_337-22"
                  data-name="Path 337"
                  transform="translate(1040.48 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -1040.48, -284.75)"
                filter="url(#Ellipse_2-10)"
              >
                <g
                  id="Ellipse_2-22"
                  data-name="Ellipse 2"
                  transform="translate(1045.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-11"
              data-name="Point Up"
              transform="translate(-22647.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -1583.48, -284.75)"
                filter="url(#Path_337-11)"
              >
                <g
                  id="Path_337-23"
                  data-name="Path 337"
                  transform="translate(1583.48 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -1583.48, -284.75)"
                filter="url(#Ellipse_2-11)"
              >
                <g
                  id="Ellipse_2-23"
                  data-name="Ellipse 2"
                  transform="translate(1588.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g
              id="Point_Up-12"
              data-name="Point Up"
              transform="translate(-22918.023 -24091.254)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -1312.48, -284.75)"
                filter="url(#Path_337-12)"
              >
                <g
                  id="Path_337-24"
                  data-name="Path 337"
                  transform="translate(1312.48 302.66)"
                  fill="#67bb4f"
                >
                  <path
                    d="M 19.5126953125 36.66193771362305 C 18.3256893157959 35.28192138671875 14.01359367370605 29.59771156311035 9.730035781860352 22.80177116394043 C 5.519335269927979 16.12142181396484 0.500005304813385 7.019791603088379 0.500005304813385 1.596601605415344 C 0.500005304813385 -0.9703084826469421 1.002625346183777 -3.460168361663818 1.993915319442749 -5.803808689117432 C 2.951485395431519 -8.067758560180664 4.32243537902832 -10.10109806060791 6.068695545196533 -11.8473482131958 C 7.814945220947266 -13.59359836578369 9.848295211791992 -14.96454811096191 12.11225509643555 -15.92211818695068 C 14.45590496063232 -16.91339874267578 16.94577598571777 -17.41601753234863 19.5126953125 -17.41601753234863 C 22.07961463928223 -17.41601753234863 24.56948471069336 -16.91339874267578 26.91314506530762 -15.92211818695068 C 29.17709541320801 -14.96454811096191 31.21044540405273 -13.59359836578369 32.95670700073242 -11.8473482131958 C 34.70295715332031 -10.10109806060791 36.07391357421875 -8.067758560180664 37.03148651123047 -5.803808689117432 C 38.02277374267578 -3.460168361663818 38.52539443969727 -0.9703084826469421 38.52539443969727 1.596601605415344 C 38.52539443969727 7.019791603088379 33.50605392456055 16.12142181396484 29.29535484313965 22.80177116394043 C 25.01179695129395 29.59770202636719 20.69969940185547 35.28191757202148 19.5126953125 36.66193771362305 Z"
                    stroke="none"
                  />
                  <path
                    d="M 19.51269340515137 35.87864303588867 C 21.06505966186523 33.96065139770508 25.07666778564453 28.5730094909668 28.96835517883301 22.38267135620117 C 31.62856483459473 18.15120124816895 33.74875640869141 14.32421112060547 35.27004623413086 11.00799179077148 C 37.09835433959961 7.022481441497803 38.02539443969727 3.856031656265259 38.02539443969727 1.596601605415344 C 38.02539443969727 -0.9030284285545349 37.53606414794922 -3.327348470687866 36.57098388671875 -5.609038352966309 C 35.63861465454102 -7.813388347625732 34.30364608764648 -9.793308258056641 32.60314559936523 -11.49379825592041 C 30.90265464782715 -13.19428825378418 28.92272567749023 -14.52924823760986 26.71836471557617 -15.46161842346191 C 24.43667602539062 -16.42668914794922 22.0123348236084 -16.91601753234863 19.5126953125 -16.91601753234863 C 17.0130558013916 -16.91601753234863 14.58872509002686 -16.42668914794922 12.30702495574951 -15.46161842346191 C 10.10266494750977 -14.52924823760986 8.122745513916016 -13.19428825378418 6.422245502471924 -11.49379825592041 C 4.721745491027832 -9.793308258056641 3.386775255203247 -7.813388347625732 2.454415321350098 -5.609038352966309 C 1.489335298538208 -3.327348470687866 1.00000536441803 -0.9030284285545349 1.00000536441803 1.596601605415344 C 1.00000536441803 3.856031656265259 1.927035331726074 7.022481441497803 3.755355358123779 11.00799179077148 C 5.276645183563232 14.3242015838623 7.396835327148438 18.15120124816895 10.05703544616699 22.38267135620117 C 13.94872283935547 28.57301712036133 17.9603271484375 33.96065521240234 19.51269340515137 35.87864303588867 M 19.5126953125 37.369140625 C 19.08342552185059 37.369140625 5.3124999794818e-06 12.37312126159668 5.3124999794818e-06 1.596601605415344 C 5.3124999794818e-06 -9.17991828918457 8.736135482788086 -17.91601753234863 19.5126953125 -17.91601753234863 C 30.28925514221191 -17.91601753234863 39.02539443969727 -9.17991828918457 39.02539443969727 1.596601605415344 C 39.02539443969727 12.37312126159668 19.94195556640625 37.369140625 19.5126953125 37.369140625 Z"
                    stroke="none"
                    fill="#67bb4f"
                  />
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -1312.48, -284.75)"
                filter="url(#Ellipse_2-12)"
              >
                <g
                  id="Ellipse_2-24"
                  data-name="Ellipse 2"
                  transform="translate(1317.67 290.19)"
                  fill="#fff"
                  stroke="#1c8000"
                  strokeWidth="1"
                >
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="14.226"
                    ry="14.226"
                    stroke="none"
                  />
                  <ellipse
                    cx="14.226"
                    cy="14.226"
                    rx="13.726"
                    ry="13.726"
                    fill="none"
                  />
                </g>
              </g>
            </g>
            <g id="Group_274" data-name="Group 274">
              {/* <use id="_02" data-name="02" transform="translate(-24096.012 -24020)" xlinkHref="#image" /> */}
              <g
                id="Group_268"
                data-name="Group 268"
                transform="translate(-131.013 -1183)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern2)"
                  onClick={() =>
                    props.data[1].characters.length > 0
                      ? navigate(`/stories/${props.data[1].id}`)
                      : props.data[1].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[1].id}`)
                  }
                  style={{
                    cursor:
                      props.data[1].characters.length > 0
                        ? "pointer"
                        : props.data[1].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>

              <g
                id="Group_269"
                data-name="Group 269"
                transform="translate(139.997 -1183)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images-2"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern4)"
                  onClick={() =>
                    props.data[3].characters.length > 0
                      ? navigate(`/stories/${props.data[3].id}`)
                      : props.data[3].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[3].id}`)
                  }
                  style={{
                    cursor:
                      props.data[3].characters.length > 0
                        ? "pointer"
                        : props.data[3].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-2"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_270"
                data-name="Group 270"
                transform="translate(410.999 -1183)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images-3"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern6)"
                  onClick={() =>
                    props.data[5].characters.length > 0
                      ? navigate(`/stories/${props.data[5].id}`)
                      : props.data[5].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[5].id}`)
                  }
                  style={{
                    cursor:
                      props.data[5].characters.length > 0
                        ? "pointer"
                        : props.data[5].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-3"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_271"
                data-name="Group 271"
                transform="translate(681.997 -1183)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images-4"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern8)"
                  onClick={() =>
                    props.data[7].characters.length > 0
                      ? navigate(`/stories/${props.data[7].id}`)
                      : props.data[7].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[7].id}`)
                  }
                  style={{
                    cursor:
                      props.data[7].characters.length > 0
                        ? "pointer"
                        : props.data[7].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-4"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_272"
                data-name="Group 272"
                transform="translate(952.999 -1183)"
              >
                <rect
                  id="images-5"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images-5"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern10)"
                  onClick={() =>
                    props.data[9].characters.length > 0
                      ? navigate(`/stories/${props.data[9].id}`)
                      : props.data[9].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[9].id}`)
                  }
                  style={{
                    cursor:
                      props.data[9].characters.length > 0
                        ? "pointer"
                        : props.data[9].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-5"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_273"
                data-name="Group 273"
                transform="translate(1223.997 -1183)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="#fff"
                />
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  transform="translate(-23965 -22813)"
                  fill="url(#pattern12)"
                  onClick={() =>
                    props.data[11].characters.length > 0
                      ? navigate(`/stories/${props.data[11].id}`)
                      : props.data[11].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[11].id}`)
                  }
                  style={{
                    cursor:
                      props.data[11].characters.length > 0
                        ? "pointer"
                        : props.data[11].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-6"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(-23887 -22835)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Group_275"
              data-name="Group 275"
              transform="translate(-24230.504 -24376)"
            >
              <rect
                id="_02-2"
                data-name="02"
                width="310"
                height="249.043"
                transform="translate(0 0)"
                fill="url(#pattern-1)"
              />
              <g
                id="Group_268-2"
                data-name="Group 268"
                transform="translate(-0.001 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />

                <rect
                  id="images-7"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern)"
                  onClick={() =>
                    props.data[0].characters.length > 0
                      ? navigate(`/stories/${props.data[0].id}`)
                      : props.data[0].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[0].id}`)
                  }
                  style={{
                    cursor:
                      props.data[0].characters.length > 0
                        ? "pointer"
                        : props.data[0].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-7"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_269-2"
                data-name="Group 269"
                transform="translate(271.007 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />

                <rect
                  id="images-8"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern3)"
                  onClick={() =>
                    props.data[2].characters.length > 0
                      ? navigate(`/stories/${props.data[2].id}`)
                      : props.data[2].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[2].id}`)
                  }
                  style={{
                    cursor:
                      props.data[2].characters.length > 0
                        ? "pointer"
                        : props.data[2].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-8"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_270-2"
                data-name="Group 270"
                transform="translate(542.007 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />

                <rect
                  id="images-9"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern5)"
                  onClick={() =>
                    props.data[4].characters.length > 0
                      ? navigate(`/stories/${props.data[4].id}`)
                      : props.data[4].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[4].id}`)
                  }
                  style={{
                    cursor:
                      props.data[4].characters.length > 0
                        ? "pointer"
                        : props.data[4].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-9"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_271-2"
                data-name="Group 271"
                transform="translate(813.003 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />

                <rect
                  id="images-10"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern7)"
                  onClick={() =>
                    props.data[6].characters.length > 0
                      ? navigate(`/stories/${props.data[6].id}`)
                      : props.data[6].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[6].id}`)
                  }
                  style={{
                    cursor:
                      props.data[6].characters.length > 0
                        ? "pointer"
                        : props.data[6].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-10"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_272-2"
                data-name="Group 272"
                transform="translate(1084.003 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />
                <rect
                  id="images-11"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern9)"
                  onClick={() =>
                    props.data[8].characters.length > 0
                      ? navigate(`/stories/${props.data[8].id}`)
                      : props.data[8].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[8].id}`)
                  }
                  style={{
                    cursor:
                      props.data[8].characters.length > 0
                        ? "pointer"
                        : props.data[8].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />
                <path
                  id="Polygon_1-11"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_273-2"
                data-name="Group 273"
                transform="translate(1354.999 0.043)"
              >
                <rect
                  id="images-6"
                  data-name="images"
                  width="225"
                  height="225"
                  fill="#fff"
                />
                <rect
                  id="images-12"
                  data-name="images"
                  width="225"
                  height="224.785"
                  fill="url(#pattern11)"
                  onClick={() =>
                    props.data[10].characters.length > 0
                      ? navigate(`/stories/${props.data[10].id}`)
                      : props.data[10].story_sets.length > 0 &&
                        navigate(`/stories/${props.data[10].id}`)
                  }
                  style={{
                    cursor:
                      props.data[10].characters.length > 0
                        ? "pointer"
                        : props.data[10].story_sets.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                />

                <path
                  id="Polygon_1-12"
                  data-name="Polygon 1"
                  d="M35,0,70,24H0Z"
                  transform="translate(148 247) rotate(180)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </Svg>
      )}
    </>
  );
};

export default Icon;
